import { render, staticRenderFns } from "./customerInfo.vue?vue&type=template&id=50aeae02&"
import script from "./customerInfo.vue?vue&type=script&lang=ts&"
export * from "./customerInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports